import { Datatable } from '../../component/Datatable/Datatable';
import { GridColDef } from '@mui/x-data-grid';
import { Delete, Edit } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 100 },
  { field: 'fullName', headerName: "Повне ім'я", width: 160 },
  { field: 'phone', headerName: 'Телефон', width: 130 },
  { field: 'city', headerName: 'Місто', width: 130 }
];

const rows = [
  { id: 1, fullName: 'Snow Jon', phone: '+380681333333', city: 'Харків' },
  { id: 2, fullName: 'Lannister Cersei', phone: '+380682333333', city: 'Хмельницьк' },
  { id: 3, fullName: 'Roxie Harvey', phone: '+380683333333', city: 'Одеса' }
];

const actionColumn = [
  {
    field: 'action',
    headerName: 'Дії',
    width: 100,
    renderCell: () => {
      return (
        <>
          <div className="cellAction">
            <Tooltip title="Редагувати">
              <IconButton>
                <Edit className="editButton" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Видалити">
              <IconButton>
                <Delete className="deleteButton" />
              </IconButton>
            </Tooltip>
          </div>
        </>
      );
    }
  }
];

const Supplier: React.FunctionComponent = () => {
  return (
    <>
      <Datatable columns={columns.concat(actionColumn)} rows={rows} />
    </>
  );
};

export { Supplier };
